import { CommonModule } from '@angular/common';
import { Component, inject, Input, TemplateRef } from '@angular/core';
import { NgbActiveModal, NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserInformationFormComponent } from '../../../components/user-information-form/user-information-form.component';
import { TableGuruComponent } from '../../../components/table-guru/table-guru.component';

import { PageHeaderComponent } from '../../../components/page-header/page-header.component';

@Component({
  selector: 'app-user-index',
  standalone: true,
  imports: [
    CommonModule,
    UserInformationFormComponent,
    NgbDropdown,
    NgbDropdownMenu,
    NgbDropdownItem,
    NgbDropdownToggle,
    TableGuruComponent,
    PageHeaderComponent
  ],
  templateUrl: './user-index.component.html',
  styleUrl: './user-index.component.scss'
})
export class UserIndexComponent {
  items: [] = [];
  private modalService = inject(NgbModal);

  reloadItems: boolean = false;
  editFormReference = UserInformationFormComponent;

  currentPage: number = 1;
  itemsPerPage: number = 10;
  searchQuery: string = '';
  filteredItems: any = [];

  sortOrder: boolean = false; // true for ascending, false for descending
  sortField: string = '';

  constructor(
  ) {
  }

  get paginatedItems() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;

    this.filteredItems = this.items.filter((item: any) =>
      item['name'].toLowerCase().includes(this.searchQuery) ||
      item['email'].toLowerCase().includes(this.searchQuery)
    );

    return this.filteredItems.slice(startIndex, endIndex);
  }

  handlePageChange(newPage: number) {
    this.currentPage = newPage;
  }

  handleSearch(query: string) {
    this.searchQuery = query.toLowerCase();
    this.currentPage = 1;
  }

  sortItems(field: string) {
    if (this.sortField === field) {
      this.sortOrder = !this.sortOrder;
    } else {
      this.sortField = field;
      this.sortOrder = true;
    }

    this.items.sort((a: any, b: any) => {
      if (a[field] < b[field]) {
        return this.sortOrder ? -1 : 1;
      }
      if (a[field] > b[field]) {
        return this.sortOrder ? 1 : -1;
      }
      return 0;
    });
  }

  openModal() {
    let self = this;
    const modalRef = this.modalService.open(UserInformationFormComponent, { size: 'lg' });
    modalRef.componentInstance.modalStyle = true;
    modalRef.result.then((result) => {
      self.reloadItems = true;

      setTimeout(() => {
        self.reloadItems = false;
      }, 200);
    });
  }
}
